import Vue from "vue";
import logger from "js-logger";
logger.useDefaults();
import _ from "lodash";
import utils from "../utils/utils";

Vue.mixin({
  data() {
    return {
      // _baseUrl: process.env.BASE_URL
    };
  },
  methods: {
    //   dateFromObjectId() {
    //     util.dateFromObjectId();
    //   },
    //   isCurrentUser(id = 1) {
    //     return id == this._currentUser._id;
    //   },
    //   moment(value) {
    //     return moment(value);
    //   }
    randomString(length = 7) {
      return Math.random()
        .toString(36)
        .substr(2, length);
    }
  },
  computed: {
    $_utils: function () {
      return utils;
    },
    _: function () {
      return _;
    },
    _initCompleted() {
      return this.$store.state.initCompleted;
    },
    _env: function () {
      return process && process.env
    },
    _app: function () {
      return {
        name: 'resi',
        iconStyle: 'far',
        url: 'localhost:8080'
      }
    },
    _user: function () {
      const user = this.$auth.user();
      return {
        isLoggedIn: this.$auth.check(),
        data: {
          ...user
        },
        fullName: `${user.name} ${user.surname}`,
        can: {
          viewAdminNav: user.roles == 'admin'
        }
      }
    }
  }
});